import { render, staticRenderFns } from "./Textfield.vue?vue&type=template&id=2396f1c4&"
import script from "./Textfield.vue?vue&type=script&lang=js&"
export * from "./Textfield.vue?vue&type=script&lang=js&"
import style0 from "./Textfield.vue?vue&type=style&index=0&id=2396f1c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports